import React from "react";
import { QuestionBox } from "../shared/QuestionBox";
import { Heading } from "../shared/Heading";
import { useContext } from "../../../../../context";
import { Options } from "../shared/Options";
import { BLOCK_FIELDS } from "../../../../../config";

export const SingleChoice = () => {
  const { blocks, previewAnswers } = useContext();
  const block = blocks.getCurrent();

  return (
    <QuestionBox>
      <Heading
        title={block[BLOCK_FIELDS.question]}
        description={block[BLOCK_FIELDS.description]}
        index={blocks.getCurrentIndex() + 1}
      />
      <Options
        list={block[BLOCK_FIELDS.choices]}
        selected={[previewAnswers.get(block.id)]}
        onSelect={(value) => previewAnswers.set(block.id, value)}
      />
    </QuestionBox>
  );
};
